import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import SearchIcon from '@mui/icons-material/Search';
import { alpha, styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useState, useEffect } from 'react';

const Search = styled('div')(({ theme }) => ({
	position: 'relative',
	borderRadius: theme.shape.borderRadius,
	backgroundColor: alpha(theme.palette.common.white, 0.15),
	'&:hover': {
		backgroundColor: alpha(theme.palette.common.white, 0.25),
	},
	marginRight: theme.spacing(5),
	marginLeft: 0,
	width: '100%',
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
	padding: theme.spacing(0, 2),
	height: '100%',
	position: 'absolute',
	pointerEvents: 'none',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
}));

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
	color: 'inherit',
	padding: theme.spacing(0, 1, 1, 0),
	// vertical padding + font size from searchIcon
	paddingLeft: `calc(1em + ${theme.spacing(4)})`,
	transition: theme.transitions.create('width'),
	border: '1px solid #f2f2f2', //light_gray
	borderRadius: ' 5px',
	width: '100%',
	'& .MuiFilledInput-root': {
		color: 'inherit',
		padding: theme.spacing(1, 0, 1, 0),
		backgroundColor: 'inherit',
		'&:hover': {
			backgroundColor: 'inherit',
		},
		'&:focus': {
			backgroundColor: 'inherit',
		},
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(4)})`,
		transition: theme.transitions.create('width'),
		width: '100%',
	},
	'& .MuiSvgIcon-root': {
		color: theme.palette.common.white,
		marginTop: '4px',
	},
}));

const ApplicationsSearch = ({ options, onChange, placeholder }) => {
	const [autoCompleteValue, setAutoCompleteValue] = useState({});

	const handleSearchChange = (_, newValue) => {
		setAutoCompleteValue(newValue);
	};

	const filterOptions = (options, { inputValue }) => {
		if (!inputValue) {
			return options;
		}
		const newOptions = options.filter(option =>
			(option.appInfo.alias + option.appInfo.applicationName)
				.toLowerCase()
				.includes(inputValue.toLowerCase())
		);

		return newOptions;
	};

	useEffect(() => {
		if (autoCompleteValue?.id) {
			onChange({
				target: {
					value: autoCompleteValue.id,
				},
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [autoCompleteValue]);

	return (
		<Search>
			<SearchIconWrapper>
				<SearchIcon />
			</SearchIconWrapper>
			<StyledAutocomplete
				id='search-menu-input'
				options={options}
				filterOptions={filterOptions}
				getOptionLabel={options => options.appInfo.applicationName}
				onChange={handleSearchChange}
				size={'small'}
				renderInput={params => (
					<TextField
						{...params}
						variant='filled'
						placeholder={placeholder ? placeholder : 'Search...'}
						InputLabelProps={{ shrink: false }}
						InputProps={{
							...params.InputProps,
							disableUnderline: true,
						}}
					/>
				)}
				renderOption={(props, option, { inputValue }) => {
					const formattedOptionLabel = option.appInfo.alias
						? option.appInfo.applicationName +
						  ' (' +
						  option.appInfo.alias +
						  ')'
						: option.appInfo.applicationName ?? '';
					const matches = match(formattedOptionLabel, inputValue);
					const parts = parse(formattedOptionLabel, matches);
					return (
						<>
							{formattedOptionLabel !== '' ? (
								<li {...props}>
									<div>
										<>
											{parts.map((part, index) => (
												<>
													<span
														key={'unigue_' + index}
														style={{
															fontWeight:
																part.highlight
																	? 700
																	: 400,
														}}
													>
														{part.text}
													</span>
												</>
											))}
										</>
									</div>
								</li>
							) : null}
						</>
					);
				}}
			/>
		</Search>
	);
};

export default ApplicationsSearch;
